export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"mintgarden.io"},{"property":"og:image","content":"/mintgarden_og_image.png"},{"name":"twitter:site","content":"@mintgarden_io"},{"name":"twitter:card","content":"summary"},{"name":"description","content":"Explore and mint NFTs in the Chia ecosystem."},{"name":"theme-color","content":"#059669"}],"link":[{"rel":"icon","href":"/mint-logo-round.svg"},{"rel":"mask-icon","href":"/mint-logo-round.svg","color":"#059669"},{"rel":"apple-touch-icon","href":"/apple-touch-icon.png","sizes":"180x180"},{"rel":"preload","href":"/fonts/Montserrat-Regular.woff2","as":"font","type":"font/woff2","crossorigin":true},{"rel":"preload","href":"/fonts/Montserrat-Medium.woff2","as":"font","type":"font/woff2","crossorigin":true},{"rel":"preload","href":"/fonts/Montserrat-SemiBold.woff2","as":"font","type":"font/woff2","crossorigin":true},{"rel":"preload","href":"/fonts/Montserrat-Bold.woff2","as":"font","type":"font/woff2","crossorigin":true},{"rel":"preload","href":"/fonts/Montserrat-ExtraBold.woff2","as":"font","type":"font/woff2","crossorigin":true},{"rel":"preload","href":"/fonts/Montserrat-Black.woff2","as":"font","type":"font/woff2","crossorigin":true}],"style":[{"children":"#nprogress {\n  pointer-events: none;\n}\n#nprogress .bar {\n  background: #059669;\n  position: fixed;\n  z-index: 99999;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n}\n/* Fancy blur effect */\n#nprogress .peg {\n  display: block;\n  position: absolute;\n  right: 0px;\n  width: 100px;\n  height: 100%;\n  box-shadow: 0 0 10px #059669, 0 0 5px #059669;\n  opacity: 1.0;\n  -webkit-transform: rotate(3deg) translate(0px, -4px);\n      -ms-transform: rotate(3deg) translate(0px, -4px);\n          transform: rotate(3deg) translate(0px, -4px);\n}\n/* Remove these to get rid of the spinner */\n#nprogress .spinner {\n  display: block;\n  position: fixed;\n  z-index: 99999;\n  top: 15px;\n  right: 15px;\n}\n#nprogress .spinner-icon {\n  width: 18px;\n  height: 18px;\n  box-sizing: border-box;\n  border: solid 2px transparent;\n  border-top-color: #059669;\n  border-left-color: #059669;\n  border-radius: 50%;\n  -webkit-animation: nprogress-spinner 400ms linear infinite;\n          animation: nprogress-spinner 400ms linear infinite;\n}\n.nprogress-custom-parent {\n  overflow: hidden;\n  position: relative;\n}\n.nprogress-custom-parent #nprogress .spinner,\n.nprogress-custom-parent #nprogress .bar {\n  position: absolute;\n}\n@-webkit-keyframes nprogress-spinner {\n  0%   { -webkit-transform: rotate(0deg); }\n  100% { -webkit-transform: rotate(360deg); }\n}\n@keyframes nprogress-spinner {\n  0%   { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}"}],"script":[],"noscript":[],"title":"MintGarden | Explore and mint NFTs in the Chia ecosystem"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false